// extracted by mini-css-extract-plugin
module.exports = {"arrow":"_1k-LH","mobile":"_3b_fe"};